import { Group } from 'three';
import { TextBlockAndButtonPlusDecor } from './TextBlockAndButtonPlusDecor';
import { ShareButton } from './ShareButton';
import { SIZE_OPTIONS, SIZE_REFS_MAP } from '../../../constants/sizes';
import { getShareTextMetrics } from './metrics/DefaultTextBlockMetrics';
import Text3D from './Text3D';
import { COLOR_DEFAULT_TEXT } from '../../../constants/colors';
import { QuizActionEvent } from '../../../constants/QuizActionEvent';

export class ResultTextBlockPlusShare extends TextBlockAndButtonPlusDecor {
    #text = '';

    constructor(title, text, buttonLabel, clickAction, decorationKey, shareCTA) {
        super(title, text, buttonLabel, clickAction, decorationKey);

        const shareG = new Group();
        // const fbButton3d = new ShareButton('fbShare', `Facebook "${title}" (3d)`);
        const vkButton3d = new ShareButton('vk', `VK "${title}" (3d)`);
        const okButton3d = new ShareButton('ok', `OK "${title}" (3d)`);

        // shareG.add(fbButton3d);
        shareG.add(vkButton3d);
        shareG.add(okButton3d);
        this.add(shareG);

        // this._fbButton3d = fbButton3d;
        this._vkButton3d = vkButton3d;
        this._okButton3d = okButton3d;
        this._shareG = shareG;
        this.#text = shareCTA;
    }

    resize(winWidth, winHeight, orientation, force, pixelRatio) {
        // this._fbButton3d.resize(winWidth, winHeight, orientation, force, pixelRatio);
        this._vkButton3d.resize(winWidth, winHeight, orientation, force, pixelRatio);
        this._okButton3d.resize(winWidth, winHeight, orientation, force, pixelRatio);

        return super.resize(winWidth, winHeight, orientation, force, pixelRatio);
    }

    _resize(winWidth, winHeight, orientation, orientationChanged, changed, pixelRatio) {
        super._resize(winWidth, winHeight, orientation, orientationChanged, changed, pixelRatio);

        if (changed) {
            if (this._shareText3d) {
                const metricsTxt = getShareTextMetrics(orientation);

                this._shareText3d.setMetrics({
                    ...metricsTxt
                });

                this._updateTextPosition(orientation);
            }
        }
    }

    setupPreloadedContent(infrastructure) {
        super.setupPreloadedContent(infrastructure);

        const metricsTxt = getShareTextMetrics(SIZE_OPTIONS.LANDSCAPE);

        const text3d = new Text3D({
            ...metricsTxt,
            color: COLOR_DEFAULT_TEXT,
            valign: 'center'
        }, this.#text, infrastructure);

        this._shareG.add(text3d);

        this._shareText3d = text3d;
    }

    _updateTextPosition(orientation) {
        super._updateTextPosition(orientation);

        const { buttonMarginTop, shareButton } = SIZE_REFS_MAP[orientation];
        const { marginSide, marginTop } = shareButton;
        const { height } = this._vkButton3d;

        let y = this._button3d.position.y - this._button3d.height * 0.5;

        y -= height * 0.5;
        y -= buttonMarginTop;

        if (this._shareText3d) this._shareText3d.position.y = y;

        y -= marginTop;

        // this._fbButton3d.position.set(-height - marginSide, y, 0);
        this._vkButton3d.position.set(-height - (marginSide / 2), y, 0);
        this._okButton3d.position.set(height + (marginSide / 2), y, 0);

        this._shareG.position.y = height * 1.5;
        this._button3d.position.y += height * 1.5;
        this._textG.position.y = height * 1.5;
    }

    // INTERACTION
    start() {
        super.start();

        let handler = this._eventTransferHandler;

        if (!handler) {
            handler = (evt) => {
                this.dispatchEvent(evt);
            };

            this._eventTransferHandler = handler;
        }

        // this._fbButton3d.addEventListener(QuizActionEvent, handler);
        this._vkButton3d.addEventListener(QuizActionEvent, handler);
        this._okButton3d.addEventListener(QuizActionEvent, handler);
        // this._fbButton3d.start();
        this._vkButton3d.start();
        this._okButton3d.start();
    }

    stop() {
        super.stop();

        if (this._eventTransferHandler) {
            // this._fbButton3d.removeEventListener(QuizActionEvent, this._eventTransferHandler);
            this._vkButton3d.removeEventListener(QuizActionEvent, this._eventTransferHandler);
            this._okButton3d.removeEventListener(QuizActionEvent, this._eventTransferHandler);
            // this._fbButton3d.stop();
            this._vkButton3d.stop();
            this._okButton3d.stop();
        }
    }
}
